import * as Sentry from '@sentry/react';

import { render } from 'react-dom';

// must be imported before `App` (which triggers Amplify.configure()) so it
// captures OAuth error params from the URL before Amplify consumes them
import './auth/capturedAuthError';
import App from './components/App';
import { setupGTM } from './components/GTMListener';
import { ENV, IS_DEV, IS_MASTER, SENTRY_DSN } from './constants';
import log, { LOG_LEVELS, setLogLevel } from './utils/log';

// https://aws-amplify.github.io/docs/js/logger#setting-logging-levels
if (!IS_MASTER) {
  setLogLevel(LOG_LEVELS.DEBUG);
}

log.debug(`IS_MASTER? ${IS_MASTER}`);

if (SENTRY_DSN) {
  const allowUrls = [
    /^https?:\/\/(www\.)?gofullpage\.com\//,
    /^https?:\/\/dev\.d32cgdvim65k7p\.amplifyapp\.com\//,
    /^https?:\/\/gen2-dev\.d32cgdvim65k7p\.amplifyapp\.com\//,
    /^https?:\/\/main\.d32cgdvim65k7p\.amplifyapp\.com\//,
  ];

  if (!IS_MASTER && window.location.hostname === 'localhost') {
    allowUrls.push(/^https?:\/\/localhost(:\d+)?\//);
  }

  const ignoreErrors = [
    // ignore errors that reference a chrome extension (unless our chrome or edge id)
    /chrome-extension:\/\/(?!(fdpohaocaechififmbbbbbknoalclacl|hfaciehifhdcgoolaejkoncjciicbemc)\/)[a-z0-9]+\//,
  ];

  // // ## ignoreErrors tests...
  // const regex = ignoreErrors[0];
  // const tests = [
  //   'chrome-extension://fdpohaocaechififmbbbbbknoalclacl',
  //   'window.fetch(chrome-extension://hoklmmgfnpapgjgcpechhaamimifchmp/frame_ant/frame_ant.js)',
  //   'chrome-extension://hfaciehifhdcgoolaejkoncjciicbemc/',
  //   'Foo bar fetch(chrome-extension://hfaciehifhdcgoolaejkoncjciicbemc/bloop)',
  // ];
  // tests.forEach((t) => console.log(t.search(regex) !== -1, t));

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV,
    allowUrls,
    enabled: !IS_DEV,
    ignoreErrors,
  });
}

setupGTM();

render(<App />, document.getElementById('root'));
